"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleDestinationBase = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../base-utils/map-creator");
var character_properties_1 = require("../../../../core/model/character/character-properties");
var enums_1 = require("../../../../core/model/character/enums");
var numbering_list_1 = require("../../../../core/model/numbering-lists/numbering-list");
var paragraph_properties_1 = require("../../../../core/model/paragraph/paragraph-properties");
var paragraph_style_1 = require("../../../../core/model/paragraph/paragraph-style");
var table_1 = require("../../../../core/model/tables/main-structures/table");
var table_cell_1 = require("../../../../core/model/tables/main-structures/table-cell");
var table_row_1 = require("../../../../core/model/tables/main-structures/table-row");
var table_cell_properties_1 = require("../../../../core/model/tables/properties/table-cell-properties");
var table_properties_1 = require("../../../../core/model/tables/properties/table-properties");
var table_row_properties_1 = require("../../../../core/model/tables/properties/table-row-properties");
var destination_1 = require("../destination");
var style_paragraph_properties_destination_1 = require("./destinations/style-paragraph-properties-destination");
var style_run_properties_destination_1 = require("./destinations/style-run-properties-destination");
var style_table_cell_properties_destination_1 = require("./destinations/style-table-cell-properties-destination");
var style_table_properties_destination_1 = require("./destinations/style-table-properties-destination");
var style_table_row_properties_destination_1 = require("./destinations/style-table-row-properties-destination");
var StyleDestinationBase = (function (_super) {
    tslib_1.__extends(StyleDestinationBase, _super);
    function StyleDestinationBase(data) {
        var _this = _super.call(this, data) || this;
        _this.numberingId = numbering_list_1.NumberingList.NumberingListNotSettedIndex;
        _this.characterFormatting = new character_properties_1.MaskedCharacterProperties();
        _this.paragraphFormatting = new paragraph_properties_1.MaskedParagraphProperties();
        _this.tableProperties = new table_properties_1.TableProperties();
        _this.tableRowProperties = new table_row_properties_1.TableRowProperties();
        _this.tableCellProperties = new table_cell_properties_1.TableCellProperties();
        _this.tabs = new paragraph_style_1.TabProperties();
        return _this;
    }
    StyleDestinationBase.getThis = function (data) {
        return data.destinationStack.getThis();
    };
    StyleDestinationBase.handlerTable = new map_creator_1.MapCreator()
        .add('pPr', function (data) {
        var thisDest = StyleDestinationBase.getThis(data);
        var parProps = thisDest.paragraphFormatting;
        parProps.setUseValue(paragraph_properties_1.ParagraphPropertiesMask.UseAll, false);
        return new style_paragraph_properties_destination_1.StyleParagraphPropertiesDestination(data, thisDest, parProps, thisDest.tabs);
    })
        .add('rPr', function (data) {
        var thisDest = StyleDestinationBase.getThis(data);
        var charProps = thisDest.characterFormatting;
        charProps.setUseValue(enums_1.CharacterPropertiesMask.UseAll, false);
        return new style_run_properties_destination_1.StyleRunPropertiesDestination(data, charProps);
    })
        .add('tblPr', function (data) {
        var thisDest = StyleDestinationBase.getThis(data);
        var tableProperties = thisDest.tableProperties;
        tableProperties.setUseValue(table_properties_1.TablePropertiesMask.UseAll, false);
        return new style_table_properties_destination_1.StyleTablePropertiesDestination(data, new table_1.Table(tableProperties, null), tableProperties);
    })
        .add('trPr', function (data) {
        var thisDest = StyleDestinationBase.getThis(data);
        var tableRowProperties = thisDest.tableRowProperties;
        tableRowProperties.setUseValue(table_row_properties_1.TableRowPropertiesMask.UseAll, false);
        return new style_table_row_properties_destination_1.StyleTableRowPropertiesDestination(data, new table_row_1.TableRow(null, tableRowProperties));
    })
        .add('tcPr', function (data) {
        var thisDest = StyleDestinationBase.getThis(data);
        var tableCellProperties = thisDest.tableCellProperties;
        tableCellProperties.setUseValue(table_cell_properties_1.TableCellPropertiesMask.UseAll, false);
        return new style_table_cell_properties_destination_1.StyleTableCellPropertiesDestination(data, new table_cell_1.TableCell(null, tableCellProperties));
    })
        .get();
    return StyleDestinationBase;
}(destination_1.ElementDestination));
exports.StyleDestinationBase = StyleDestinationBase;
